/* eslint-disable max-len */

export default {
  lang: 'German',
  sharing: {
    email: 'E-Mail',
    facebook: 'Facebook',
    twitter: 'Twitter',
    download: 'Herunterladen',
    print: 'Drucken',
    copy: 'Link kopieren',
    copyUrl: 'Link kopieren',
    copied: 'Kopiert',
    shareSubjectDiploma: 'Mein Kanada-Spezialistenprogramm-Diplom',
    shareSubjectBadge: 'Mein Abzeichen für das Kanada-Spezialistenprogramm',
    shareBodyDiploma:
      'Ich freue mich, mitteilen zu können, dass ich jetzt ein zertifizierter Kanada-Spezialist bin! Das bedeutet, dass ich über das Fachwissen und Insiderzugang verfüge, um Ihnen bei der Planung Ihres bestmöglichen Urlaubs zu helfen. Bitte kontaktieren Sie mich, wenn Sie bereit sind, mit der Planung zu beginnen.',
    shareBodyBadge:
      'Ich wollte Sie darüber informieren, dass ich jetzt ein zertifizierter Spezialist für {chapterTitle} bin, und ich stehe Ihnen gerne zur Beantwortung Ihrer Fragen zur Verfügung und helfe Ihnen bei der Planung Ihrer nächsten erstaunlichen Reise. Lassen Sie mich wissen, wenn Sie bereit sind loszulegen!',
  },
  homeScreen: {
    title: 'Unglaublich einzigartig', // Product specific
    stayConnected: 'Bleiben Sie verbunden:',
    comingSoon: 'Demnächst verfügbar',
    messages: 'Nachricht',
  },
  loginScreen: {
    forgot: "Passwort zurücksetzen",
    version2: {
      homeTitle: "Schauen wir mal, ob wir in unserem System ein Profil für Sie finden können.",
      homeTitleSub: "Geben Sie die E-Mail-Adresse ein, die Sie normalerweise für die Anmeldung bei Schulungsprogrammen verwenden.",
      noAccount: "Kein Konto gefunden ({email}), bitte versuchen Sie es mit einer anderen E-Mail oder erstellen Sie jetzt ein Konto.",
      continueButton: "Weiter",
      success: "Sie haben Ihr Konto erfolgreich aktualisiert! Sie werden in Kürze auf die Startseite weitergeleitet.",
      successNewAccount: "Um Ihre Anmeldung abzuschließen, erhalten Sie eine Bestätigungs-E-Mail, um Ihr Konto zu verifizieren.",
      loginButton: "Anmeldung",
      matchFound: "Wir haben eine Übereinstimmung gefunden. Bitte geben Sie Ihr Passwort ein, um fortzufahren.",
      magicLink: "Melden Sie sich über einen Link in Ihrer E-Mail an:",
      magicLinkButton: "Magic Link anfordern",
      magicLinkTitle: "Lassen Sie sich einen direkten Link an Ihre E-Mail schicken, mit dem Sie sich sofort anmelden können.",
      otherEmailButton: "Einreichen",
      title: "Bitte nehmen Sie sich einen Moment Zeit, um alle nachstehenden Informationen auszufüllen, da dadurch Ihr persönliches Profil und Ihre Kontaktinformationen erstellt werden.",
      titleIndustry: "Bitte nehmen Sie sich einen Moment Zeit, um alle nachstehenden Informationen auszufüllen, da dadurch Ihr persönliches Profil und Ihre Kontaktinformationen erstellt werden.",
      register: "Ein Konto erstellen",
      agent: "Reiseberater",
      visitor: "Industrie Besucher",
      step1: "Schritt 1: Art des Nutzers",
      step2: "Schritt 2: Ein Konto erstellen",
      step3: "Schritt 3: Erstellen Sie Ihr Profil",
      milesAttack: 'Do you have a Miles Attack code? Indicate the 4 letters',
      marketingOptIn: "Sind Sie sicher, dass Sie nicht daran interessiert sind, mit dem Travel Trade Team dieses Programms in Verbindung zu bleiben?",
      optIn: "Ja, ich bin interessiert",
      optOut: "Nicht Interessiert",
      step2Sub1: "Erzählen Sie uns von sich selbst",
      step2Sub2: "Erzählen Sie uns von Ihrem Unternehmen",
      privacyHead: "KOMMUNIKATIONSPRÄFERENZEN",
      privacySub: "Kreuzen Sie die unten stehenden Kästchen an, um sicherzustellen, dass Sie wichtige Mitteilungen vom Reisebüroteam des Anbieters (Produktaktualisierungen und -ankündigungen, Prämien, Incentives, FAMs usw.) sowie Netzwerk- und Verkaufsförderungsinitiativen von TravPRO Mobile erhalten.",
      privacy: "Wir schützen Ihre Privatsphäre und verkaufen, missbrauchen oder betrügen niemals Ihr Vertrauen.",
      store: "Laden Sie dieses Programm ganz einfach in Ihrem App-Store herunter:",
      powered: "ANGETRIEBEN DURCH",
      toastMessage: {
        forgotSuccess: "Wir haben Ihnen den Link zum Zurücksetzen Ihres Passworts per E-Mail geschickt! Sie werden in 10 Sekunden zur Login-Seite weitergeleitet.",
        emailNotExisting: "Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.",
        magicLinkMessage: "Bitte warten Sie, wir melden Sie gerade an.",
        magicLinkError: "Wir konnten Ihr Konto nicht in unserer Datenbank finden. Bitte melden Sie sich manuell an. Sie werden in 10 Sekunden weitergeleitet.",
        magicLinkError1: "Wir konnten keinen gültigen Token finden, bitte melden Sie sich an oder fordern Sie einen neuen magischen Link an.Wenn dieses Problem weiterhin besteht, kontaktieren Sie uns bitte unter: info@travpromobile.com.",
        magicLinkError2: "Wir konnten Ihr Konto nicht in unserer Datenbank finden. Bitte melden Sie sich manuell an.Sie werden in 10 Sekunden weitergeleitet.",
        magicLinkSuccess: "Prüfen Sie Ihre E-Mail an {email}.Sie enthält einen magischen Link, mit dem du dich anmelden kannst.",
        magicLinkErrorWait: "Bitte warten Sie 5 Minuten zwischen den Anfragen nach magischen Links.",
        emailNotFoundError: "Die von Ihnen eingegebene E-Mail-Adresse kann in unseren Unterlagen nicht gefunden werden. Bitte prüfen Sie auf Schreibfehler oder erstellen Sie ein Konto."
      },
      errors: {
        zipCodeNotFound: "ZipCode nicht gefunden, versuchen Sie es erneut",
        zipCodeOnlyNumbers: "ZipCode kann nur Zahlen enthalten",
        password: "Bitte geben Sie ein Passwort ein",
        passwordNotMatching: "Die von Ihnen eingegebenen Passwörter stimmen nicht überein",
        passwordTooShort: "Das Passwort muss mindestens 8 Zeichen lang sein.",
        emailExists: "Diese E-Mail Adresse existiert bereits oder ist ungültig. Bitte versuchen Sie es mit einer anderen E-Mail-Adresse oder melden Sie sich bei Ihrem Konto an.",
        fillInAllFields: "Bitte füllen Sie alle erforderlichen Felder aus",
        fillInEmail: "Bitte geben Sie Ihre E-Mail-Adresse an.",
        emailNotExisting: "Die von Ihnen eingegebene E-Mail-Adresse existiert nicht."
      },
      fields: {
        forgotSubCopy: "Sie haben Ihr Passwort vergessen und möchten es ändern? ",
        forgotSubCopy2: "Möchten Sie das Passwort ganz umgehen? Wir schicken Ihnen eine E-Mail mit einem magischen Link, der Sie automatisch beim Programm anmeldet.",
        city: "Stadt",
        companyName: "Name des Unternehmens",
        role: "Ihre Rolle",
        description: "Was beschreibt das Geschäft Ihres Unternehmens am besten?",
        country: "Land",
        password: "Passwort",
        passwordRegister: "Passwort wählen (mindestens 8 Zeichen)",
        passwordConfirm: "Bestätigen Sie Ihr Passwort",
        firstName: "Vorname (gegeben)",
        lastName: "Nachname (Familie)",
        agency: "Name Ihrer Agentur",
        title: "Ihre Rolle (Wählen Sie eine aus)",
        company: "Name des Unternehmens",
        select: "Wählen Sie unten eine Option",
        state: "Staat",
        province: "Bundesland/Region/Staat",
        zipCode: "Postleitzahl",
        postalCode: "Postleitzahl",
        affiliate: "Welcher Gruppe gehören Sie in erster Linie an?",
        hostAgency: "Ihre Aufnahmeagentur?",
        executive: "Exekutive",
        management: "Verwaltung",
        marketing: "Marketing",
        sales: "Vertrieb",
        coordinator: "Koordinator",
        opt: "Bleiben Sie mit dem Team dieses Programms in Verbindung und erhalten Sie aktuelle Informationen.",
        optMarketing: "Bleiben Sie mit TravPRO in Verbindung, wenn es um ähnliche Programme und Veranstaltungen geht.",
        retail: "Einzelhandelsgeschäft Front",
        home: "Home-Based Agent",
        independent: "Unabhängiger Auftragnehmer",
        host: "Gastgeber-Agentur",
        call: "Call Center oder Web-basierte Agentur",
        other: "Andere",
        describes: "Was beschreibt Sie und die Tätigkeit Ihrer Agentur am besten?",
        milesAttack: 'Code Miles Attack (facultatif)',
      }
    },
    title: 'Professionelles Schulungs- und Vertriebs-Programm für Reiseberater',
    welcome: {
      headerTop: 'Willkommen zum',
      headerBottom: 'Canada Specialist Program', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Unterwegs lernen, fördern und verkaufen',
      1: 'Geräteübergreifendes Multimedia-Training',
      2: 'Abschlussbescheinigung',
      3: 'Vorgefertigte Verkaufspräsentationen',
      4: 'Wirkungsstarke Werbematerialien',
      5: 'Insider-Tipps & Werbeaktionen',
      6: 'Echtzeit-Produktverzeichnis',
      7: 'Rechtzeitige Nachrichten und Updates',
    },
    emailPrompt: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um zu bestätigen, dass Sie ein Reiseberater sind.',
    tAndC: {
      agree: 'Indem Sie fortfahren, stimmen Sie unserem ',
      privacyPolicy: 'Datenschutz-Bestimmungen ',
      and: ' und ',
      termsConditions: 'Geschäftsbedingungen zu.',
    },
    fields: {
      select: 'Wählen Sie unten eine Option aus',
      country: 'Land',
      forgot: 'Passwort vergessen? Klicken Sie auf die Schaltfläche unten und wir senden Ihnen eine E-Mail, um Ihr Passwort zurückzusetzen.',
      password: 'Passwort',
      passwordConfirm: 'Bestätigen Sie Ihr Passwort',
      agency: 'Agentur',
      email: 'E-Mail',
      firstName: 'Vorname *',
      lastName: 'Nachname *',
      city: 'Stadt *',
      address: 'Adresse *',
      postalCode: 'Postleitzahl *',
      agencyName: 'Name der Agentur *',
      stateProvince: 'Staat/Provinz *',
      registrationCode: 'Werbe-Code (wahlweise)',
      required: 'Notwendig',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      opt: 'In Kontakt bleiben! Ja, ich möchte mich für Mitteilungen von Destination Canada anmelden, die mich über Neuigkeiten, Veranstaltungen, Incentives, FAMs und mehr auf dem Laufenden halten.',
    },
    noAgent: {
      noAgentButton: 'Ich bin kein Reiseberater',
      title: 'Vielen Dank für Ihr Interesse in Canada.',
      messageWeb:
        'Der Inhalt dieser Webseite ist ausschließlich für Reiseveranstalter bestimmt. Um mehr über Canada Specialist zu erfahren, besuchen Sie bitte:',
      messageMobile:
        'Einige Inhalte dieser App sind ausschließlich für Reiseveranstalter bestimmt, Sie können jedoch eine Vorschau des Angebots dieser App anzeigen, indem Sie auf "Fortfahren" klicken.',
      continue: 'Fortfahren',
      visitWebsite: 'Webseite besuchen >',
    },
    newUser: 'Neuer Benutzer',
    register: 'Registrieren',
  },
  welcomeScreen: {
    title: 'Willkommen bei der Destination Canada-Verkaufshilfe',
    helloUser: 'Hallo {name}',
    hello: 'Hallo,',
    fromAgency: 'von {agency}',
    notUser: 'Sind Sie Nicht {name}?',
    introOnline: 'Schulen Sie sofort online oder laden Sie den Inhalt vorab, sodass er immer offline verfügbar ist!',
    introOffline:
      'Sie haben bereits die neueste Version vorinstalliert. Beginnen Sie zu jeder Zeit und an jedem Ort mit dem Training oder Verkauf!',
    startTraining: 'Fortfahren',
    downloader: {
      preload: 'vorher laden',
      stop: 'stop',
      init: 'Initialisierung ...',
      lastUpdate: 'letztes Update',
    },
  },
  trainingScreens: {
    completedBase: 'Herzlichen Glückwunsch, Sie sind ein zertifizierter Kanada-Spezialist.',
    review: 'Erneut anschauen >',
    unlock: 'Schalten Sie dieses Kapitel frei, indem Sie das Schulungskapitel {number} abschließen.',
    skip: 'Zurückkehren >',
    viewAllTitle: 'Trainingstipp',
    viewAll:
      'Um zur nächsten Seite zu gelangen, klickt bitte auf die Symbole, um die ergänzenden Inhalte anzuzeigen. Videos, Karten und andere hilfreiche Informationen wurden bereitgestellt, um das Training zu bereichern und sicherzustellen, dass ihr den PRO-Status erreicht.',
    start: 'Beginnen',
    continue: 'Fortfahren',
    welcome:
      'Willkommen in unserem neu gestalteten Trainingsbereich. Schließt einfach Module ab, um dem Ziel, Canada Specialist Gold zu werden, immer näher zu kommen! Rechts seht ihr euren Fortschritt.',
    restart: 'Neustart',
    durationInMinutes: '{number} Minuten',
    percentageComplete: '{number}% abgeschlossen',
    unlock: 'Entsperren Sie dieses Kapitel, indem Sie das Schulungskapitel abschließen',
    unlockSubtitle: 'Entsperren Sie weitere Kapitel, indem Sie Schulungskapitel abschließen.',
    unlockFoundation: 'Schalte dieses Kapitel frei, indem du die Foundation-Kapitel abschließt.',
    allUnlocked: 'Du hast alle Kapitel freigeschaltet!',
    certificate: 'Zertifikat',
    courseComplete: 'Kurs abgeschlossen!',
    chapterComplete: 'Kapitel abgeschlossen!',
    message: '{count} Nachricht',
    messagePlural: '{count} Nachrichten',
    endReached: 'Du bist am Ende angelangt',
    retainEnd:
      'Verwenden Sie die obere Leiste, um in diesem Kapitel zu navigieren, oder drücken Sie die Zurück-Taste, um zur Übersicht zurückzukehren.',
    watchListenRead: 'Sehe, höre und lese mehr',
    trouble:
      'Um die Frage beantworten zu können, lies gerne den Inhalt der vorherigen Seite(n) noch einmal durch und versuche es erneut.',
    confirm: 'Bestätige deine Antwort',
    choose: 'Bitte wähle eine Antwort',
    chapter: 'Kapitel',
    essential: 'Grundlegende Module',
    essentialSub: 'Mit Abschluss dieser Module habt ihr den Canada Specialist Bronze Status erreicht.',
    specialization: 'Spezialisierungsmodule',
    specializationSub: 'Schließen Sie diese Module ab, um Ihren Silber Canada Specialist-Status zu erreichen',
    status: 'Aktueller Status',
    completed: '{completed} / {total} abgeschlossen',
  },
  nav: {
    home: 'Startseite',
    train: 'Lernen',
    retain: 'Einprägen & auffrischen',
    achievements: 'Leistungen',
    directory: 'Verzeichnis',
    promote: 'Promoten',
    sell: 'Verkaufen',
    rewards: 'Belohnungen',
    info: 'Info',
    media: 'Medien',
    favorites: 'Favoriten',
    contact: 'Kontakt',
    reportCard: 'Zertifikat',
    accountSettings: 'Account-Einstellungen',
    messages: 'Nachrichten',
    search: 'Suchen',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: 'Lernen',
    retain: 'Einprägen & auffrischen',
    subapps: 'Canada Partner Mini-Training',
    maintrainings: 'Grundlegende Module',
    subtrainings: 'Das Kanada-Erlebnis',
  },
  pageDescriptions: {
    train: 'Weiterbilden und Experte werden.',
    showroom: '',
    retain:
      'Deine Anlaufstelle um dein Wissen aufzufrischen und einzuprägen. Nutze diesen Bereich gerne um Fragen fachmännisch zu beantworten oder sogar als spontane Verkaufspräsentation – jederzeit, überall und von jedem Gerät aus.',
    promote: 'Starten Sie das Gespräch mit Ihren Kunden und Interessenten.',
    sell: 'Beantworten Sie Kundenfragen und schließen Sie den Verkauf ab.',
    favorites: 'Schauen Sie sich Ihre persönlich favorisierten Inhalte an',
    search: 'Alle Inhalte durchsuchen',
    subapps:
      'Bringen Sie Ihr Wissen auf die nächste Stufe und verdienen Sie sich eine Auszeichnung für JEDES abgeschlossene Kapitel einer Provinz, eines Territoriums oder einer Stadt. Schließen Sie 10 der insgesamt 29 Kapitel ab und erreichen Sie den GOLD-Status. Beenden Sie 22 der insgesamt 29 Kapitel und erreichen Sie den höchsten Spezialistenstatus, PLATINUM!',
    maintrainings: 'Absolviert die grundlegenden Module, um das Zertifikat zu erhalten.',
    subtrainings:
      'Entdecken Sie Kanadas unglaubliche Aktivitäten und Abenteuer, um den SILBER-Status zu erreichen und Ihr Diplom zu erhalten!',
  },
  general: {
    forgot: "Passwort zurücksetzen",
    next: 'nächste',
    previous: 'Zurück',
    submit: 'Absenden',
    back: 'Zurück',
    close: 'Schließen',
    register: 'Registrieren',
    page: 'Seite',
    contact: 'Kontakt',
    search: 'Suchen',
    logIn: 'Einloggen',
    logOut: 'Ausloggen',
    viewItem: '{type} ansehen',
    imageNotFound: 'Bild nicht gefunden',
    noResultsFor: 'Es wurden keine Ergebnisse gefunden für: {query}',
    noFavorites: 'Du hast noch keine Favoriten.',
    noMessages: 'Du hast noch keine Nachrichten erhalten!',
    resultsFor: 'Ergebnisse für {query}',
    showAll: 'Zeige alles',
    connectionError: 'Verbindungsfehler',
    alreadyExists: 'ist bereits vorhanden',
    pageNotFound: '',
    oops: '',
    overview: 'zurück zur Übersicht',
    complete: 'Kurs abgeschlossen!',
    share: 'Teilen',
    destinations: 'Canada Partner Mini-Training',
    essentials: 'Das Wesentliche von Canada',
    trainingLibrary: 'Schulungsbibliothek',
    message: '{count} Nachricht',
    messagePlural: '{count} Nachrichten',
    courseComplete: 'Kurs abgeschlossen!',
    chapterComplete: 'Kapitel abgeschlossen!',
  },
  itemTypes: {
    image: 'Bild',
    brochure: 'Sammlung',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Sammlung',
  },
  questions: {
    dials: 'Drehen Sie die Drehregler, um die Antwort abzugleichen',
    fitb: 'Fülle die Lücken aus',
    flip: 'Ändern Sie die Nummer entsprechend der Antwort',
    multipleChoice: 'Wählen Sie die richtigen Antwort(en) aus.',
    slider: 'Ziehen Sie den Balken nach rechts und stoppen Sie bei Ihrer Antwort.',
    map: 'Tippen Sie die Antwort auf der Karte an.',
    dropdown: 'Wähle...',
    true: 'Wahr',
    false: 'Falsch',
  },
  cookies: {
    consent: 'Zustimmen',
    optout: 'Aussteigen',
    settings: 'Datenschutzeinstellungen',
    message:
      'Sie haben uns nichts über Ihre Datenschutzpräferenzen erzählt! Das ist in Ordnung, aber wir möchten Ihnen die beste Erfahrung mit dem Sales Companion bieten.',
    disabled: 'Sie haben anscheinend die Verwendung von Cookies deaktiviert.',
    use: 'Der {appName} erfordert die Verwendung von Cookies, um Ihnen die bestmögliche Erfahrung zu bieten.',
    details: 'Wozu werden Cookies verwendet?',
    enable: 'So aktivieren Sie Ihre Cookies {here}.',
    here: 'hier',
  },
  notLoggedIn: {
    super: 'Du bist nicht angemeldet',
    title: 'Sie müssen angemeldet sein, um diesen Inhalt anzeigen zu können',
    guest: 'Gast',
  },
  demo: {
    message: '',
    consent: 'Begriffen!',
  },
  share: {
    header: 'Teilen Sie diese Ressource in Ihren bevorzugten sozialen Netzwerken!',
    download: 'download',
  },
  breadCrumbs: {
    page: 'Seite',
  },
  onMobile: {
    header: 'Anscheinend versuchen Sie, über ein Mobilgerät auf die App {appName} zuzugreifen',
    body: 'Um dieses Programm herunterzuladen, besuchen Sie einfach Ihren App Store und suchen Sie nach {appName} oder klicken Sie auf eine der Schaltflächen unten',
    benefits: {
      header: 'Damit erhalten Sie:',
      1: 'Portabilität',
      2: 'Keine Notwendigkeit für WLAN, trainieren, wann und wo es bequem ist',
      3: 'Verkaufstools und -ressourcen an Ihren Fingerspitzen',
    },
  },
  popUp: {
    congratulations: 'CONGRATULATIONS!',
    bronze:
      'Gute Arbeit! Sie haben alles über Kanada gelernt und sich den BRONZE-Status verdient. Als Nächstes werden wir die vielen Arten von Erfahrungen untersuchen, die Besucher hier haben können.',
    silver:
      'Herzliche Glückwünsche! Sie haben Ihr Diplom als zertifizierter Kanada-Spezialist erworben, indem Sie alle Module in The Foundation und The Experience erfolgreich abgeschlossen haben. Ihr Diplom kann jederzeit oben in Ihrem Lern-Dashboard angezeigt und heruntergeladen werden. Sie haben auch den SILBER-Status erreicht und sind bereit, GOLD und darüber hinaus zu erreichen, indem Sie mit dem Abschnitt „Provinzen, Territorien und Städte“ weiter unten fortfahren. Mach weiter so!',
    gold: 'Gute Arbeit! Sie haben 10 Provinzen, Territorien & Städte-Module erfolgreich abgeschlossen und haben jetzt den GOLD-Status erreicht. Entscheiden Sie sich, weitere 12 zu absolvieren, und Sie werden ein Kanada-Spezialist auf PLATIN-Niveau!',
    platinum: 'Herzliche Glückwünsche!! Sie haben den PLATINUM-Status erreicht – die höchste Qualifikationsstufe als zertifizierter Kanada-Spezialist. Vielen Dank für all Ihre harte Arbeit und Ihre Partnerschaft beim Verkauf von Kanada.',
    platinumWithLink: {
        start:
            'You have just achieved PLATINUM status as a Canada Specialist. You are truly at the top of the class now, well done! You have earned some rewards for your hard work. Click',
          end: 'to visit your Achievements Dashboard and learn how to redeem exclusive PLATINUM deals and offers from our partners.',
          link: 'HERE',
    },
  },
  newTrainingFlow: {
    tip: 'Tipp: Sie verdienen Ihren Status, indem Sie die Module innerhalb jeder Stufe abschließen. Haben Sie großartige Träume und erreichen Sie den Gold Canada Specialist Plattform-Status indem Sie alle Module abschließen!',
    essentialModules: 'Wichtige Kapitel',
    finishBronze: 'Schließen Sie diese Module ab, um Ihren Bronze-Canada Specialist Plattform-Status zu verdienen',
    specializationModules: 'Spezialisierungsmodule',
    finishSilver:
      'Entdecken Sie Kanadas unglaubliche Aktivitäten und Abenteuer, um den SILBER-Status zu erreichen und Ihr Diplom zu erhalten!',
    partnerModules: 'Partnermodule',
    finishGold:
      'Bringen Sie Ihr Wissen auf die nächste Stufe und verdienen Sie sich eine Auszeichnung für JEDES abgeschlossene Kapitel einer Provinz, eines Territoriums oder einer Stadt. Schließen Sie 10 der insgesamt 29 Kapitel ab und erreichen Sie den GOLD-Status. Beenden Sie 22 der insgesamt 29 Kapitel und erreichen Sie den höchsten Spezialistenstatus, PLATINUM!',
    currentStatus: 'Aktueller Status',
    pointsToLevel: '{pointsToLevel} {points}',
    reachedRanking: 'bis Sie den {rank} Rang erreicht haben!',
    outOf: '{points} XP von',
    pointsToRank: '{pointsToLevel} XP für Rang erforderlich: ({rank})',
    essential: 'Grundlegende Module',
    essentialSub: 'Schließen Sie diese Module ab, um Ihren Bronze-Canada Specialist Plattform-Status zu verdienen',
    specialization: 'Spezialisierungsmodule',
    specializationSub: 'Schließen Sie diese Module ab, um Ihren Silber Canada Specialist Plattform-Status zu erreichen',
    completed: '{completed} / {total} abgeschlossen',
  },
  points: {
    completed: '{completed} / {total} abgeschlossen',
  },
  rewards: {
    profile: 'Dein Profil',
    rewards: 'Belohnungen',
    title: 'Willkommen im Belohnungszentrum',
    subheader: 'Verfolge und teile Buchungseinreichungen und Belohnungen',
    subTitle:
      'Du hast die Chance, Belohnungen zu gewinnen, wenn du durch unser Programm Spezialist wirst und Reisen nach Kanada buchst!',
    body: 'Buche eine Reise nach Kanada und sichere dir deine Gewinnchance! Reiche deine Buchungen ein, um eine Einführungsprämie in Form einer $5 US/CAN E-Geschenkkarte zu erhalten.',
    item1:
      'Nach deiner ersten bestätigten Buchung von 4 Nächten oder mehr (Einzelreservierung), für mindestens zwei (2) Personen, in einem qualifizierenden Hotel/Resort. (Kreuzfahrten sind nicht qualifiziert.)',
    item2: 'Das Angebot ist gültig, nachdem die wesentlichen Module des Canada Specialist Programms abgeschlossen wurden.',
    link1: 'Hast du Kanada gebucht?',
    link2: 'Wenn ja, reiche deine Buchung hier ein.',
    button: 'Buchung einreichen',
    products: 'Marktplatz',
    viewAllBookings: 'Buchungsübersicht',
    viewLeaderboard: 'Bestenliste',
    viewDashboard: 'Leistungsübersicht',
    viewRewards: 'Belohnungshome',
    form: 'BUCHUNG EINREICHEN',
    menu: {
      home: 'Belohnungs-\nzentrum',
      achievements: 'Trainings-\nleistungen',
      bookings: 'Buchungs-\nübersicht',
      form: 'Buchungen\nEinreichen',
    },
    overview: {
      title: 'Willkommen im Belohnungszentrum des Canada Specialist Programms.',
      subtitle: 'Nutze diesen Bereich, um deinen Trainingsfortschritt, Leistungen und Belohnungen zu verfolgen.',
      description: 'So funktioniert’s:',
      dashboard: {
        title: 'Leistungsübersicht',
        description:
          'Verfolge deinen Trainingsfortschritt, dein Diplom und erhaltene Abzeichen in der Leistungsübersicht. Wenn du dich von Bronze bis Platin hocharbeitest, kannst du deinen Status im Fortschrittsbalken beobachten.',
        bronze: 'BRONZE-Status wird nach Abschluss der Grundlagenmodule erreicht',
        silver: 'SILBER-Status wird zusammen mit dem Diplom nach Abschluss der Erfahrungs-Module erreicht',
        gold: 'GOLD-Status wird nach Abschluss von 10 Provinz-/Territorien-/Städte-Kapiteln erreicht',
        platinum: 'PLATIN-Status wird nach Abschluss von 22 Provinz-/Territorien-/Städte-Kapiteln erreicht',
      },
      platinumRewards: {
        title: 'Platin-Belohnungen',
        description:
          'Platin-Level Canada Specialists erhalten exklusive Belohnungen wie "Destination Experience Pässe" unserer Partner. Sobald du dein Platin-Abzeichen in der Übersicht erhältst, bekommst du eine Liste der verfügbaren Pässe sowie Anweisungen zur Einlösung. Für die Einlösung musst du dein Platin-Abzeichen herunterladen und zur Verifizierung senden.',
      },
      downloads: {
        title: 'Downloads',
        description:
          'In der Leistungsübersicht kannst du dein Canada Specialist Diplom, Abzeichen für Provinzen/Territorien/Städte sowie deine Metallstatus-Abzeichen anzeigen und herunterladen. Einfach auf das Symbol klicken und auf dem Rechner speichern oder teilen.',
      },
      termsNotice: {
        start: 'Siehe Bedingungen',
        end: 'für weitere Details.',
        link: ' Geschäftsbedingungen ',
      },
      rewards: {
        title: 'Belohnungen',
        description: {
          start: 'Platin-Level Canada Specialists erhalten exklusive Belohnungen wie',
          end: 'von unseren Zielgebietspartnern. Nach Erhalt deines Platin-Abzeichens erhältst du eine Liste der verfügbaren Pässe und Einlösehinweise.',
          bold: 'Destination Experience Pässe',
        },
      },
    },
    home: {
      entries: 'Aktuelle Teilnahmen',
      trainingAchievements: 'TRAININGSLEISTUNGEN',
      trainingAchievementsText:
        'Verfolge deinen Trainingsfortschritt, Zertifizierungen und deinen Belohnungsstatus. Du kannst außerdem dein Diplom und erhaltene Abzeichen herunterladen und teilen.',
      bookingDashboard: 'BUCHUNGSÜBERSICHT',
      bookingDashboardText: 'Verwalte und verfolge deine aktuellen Buchungen einfach im Dashboard.',
      submitBooking: 'BUCHUNGEN EINREICHEN',
      submitBookingText: 'Hier kannst du Buchungen für Wettbewerbe einreichen.',
      currentContest: 'AKTUELLER WETTBEWERB',
      currentContests: 'AKTUELLE WETTBEWERBE',
      contestHeader: 'Gewinne jeden Monat Geldpreise für Buchungen!',
      contestPrizes:
        'Reiche jeden Monat Hotel-, Bodendienste- und Mietwagenbuchungen ein und gewinne einen dieser drei tollen Preise:',
      contestPrize1: 'Eine (1) Geschenkkarte im Wert von 250 $',
      contestPrize1Description: ' wird an den Berater mit den meisten Buchungen im Monat vergeben*',
      contestPrize2: 'Zwei (2) Geschenkkarten im Wert von 100 $',
      contestPrize2Description: ' werden unter zwei Beratern per Zufall verlost',
      contestConditions: '*Eine (1) Teilnahme pro qualifizierender Buchung:',
      contestLodging: 'Unterkunft: ',
      contestCondition1: 'Buchungen müssen mindestens 3 Nächte umfassen',
      contestGroundServices: 'Bodendienste:  ',
      contestCondition2: 'mindestens 3 Dienstleistungen (z. B. Empfang, Transfer, Sightseeing)',
      contestCarRental: 'Mietwagen: ',
      contestCondition3: 'mindestens 3 Tage',
      contestStartEarning: 'Sichere dir deine Gewinnchancen durch ',
      contestEnterBookings: 'Einreichen deiner Buchungen',
      contestNow: ' jetzt!',
      contestSeeOther: 'Weitere ',
      contestTerms: 'Geschäftsbedingungen',
    },
    bookingRewardsView: {
      title: 'Marktplatz',
    },
    bookingsView: {
      rowsPerPage: 'Zeilen pro Seite',
      rangeSeparator: 'von',
      selectAllRowsItem: 'alle',
      title: 'Buchungsübersicht',
      subtitle: 'Verwalte und verfolge deine Buchungseinreichungen hier.',
      manage: 'Buchungen verwalten',
      manageSub:
        'Verwende die Buttons oben, um zu sortieren, und klicke auf einen Eintrag, um Details zu bearbeiten. Alle ausstehenden Einreichungen werden innerhalb von 72 Stunden überprüft.',
      noBookings: 'Keine Einträge zum Anzeigen.',
      statusCategories: {
        confirmedentries: "Bestätigte Einträge",
        pendingentries: "Ausstehende Einträge",
        rejectedentries: "Abgelehnte Einträge",
        viewall: "Alle anzeigen"
      },
      columns: {
        reservationNumber: "Reservierungsnummer",
        status: "Status",
        firstName: "Vorname",
        numberOfGuests: "Anzahl der Gäste",
        lengthOfStay: "Aufenthaltsdauer",
      }
    },
    leaderboardScreen: {
      title: 'LC PUNKTE\nBestenliste',
      earnedpts: 'MEINE GESAMMELTEN LC PUNKTE:',
      pointsWall: 'TOP 5 LC PUNKTE VERFOLGER:',
      startEarning: 'Sammle jetzt XP und tritt der Bestenliste bei!',
      prizes: 'Preise',
      tAndC: 'Es gelten die Geschäftsbedingungen*',
      pointsOverview: {
        title: 'So sammelst du Punkte',
        booths: 'Besuche Ausstellerstände',
        breakoutSessions: 'Nimm an Sessions und Präsentationen teil',
        trainingSessions: 'Schließe ein Trainingskapitel ab',
        adventureSpotlights: 'Reisetipps für Familien',
        share: 'Inhalte teilen',
        shareMax: '(bis zu {maxSharePoints} Punkte)',
        shareInfo:
          'Teilen zählt, wenn du Inhalte auf Twitter, Facebook oder mit Kollegen/Kunden teilst.',
        viewVideo: 'Video ansehen',
      },
    },
    dashboardView: {
      title: 'Dein Verdienst-Dashboard',
    },
    bookingForm: {
      title: 'Buchungsformular',
      subTitle: 'Gib deine Buchung ein:',
      required: '* Pflichtfeld',
      email: 'Berater-E-Mail',
      agentFirstName: 'Vorname des Beraters',
      agentLastName: 'Nachname des Beraters',
      company: 'Agentur / Firmenname',
      iata: 'IATA/CLIA-Nummer',
      stateProvince: 'Bundesstaat / Provinz',
      postalCode: 'Postleitzahl',
      country: 'Land',
      city: 'Stadt',
      birthday: 'Geburtsdatum',
      type: 'Art der Reise',
      source: 'Buchungsquelle',
      select: 'Bitte wähle eine Option',
      tourOperator: 'Reiseveranstalter',
      provinceVisited: 'Besuchte Provinz oder Territorium',
      firstName: 'Vorname des Gastes',
      lastName: 'Nachname des Gastes',
      bookingNumber: 'Bestätigungsnummer',
      file: 'RezSnap™ Nachweis hochladen',
      arrivalDate: 'Anreisedatum',
      pax: 'Personenanzahl',
      departureDate: 'Abreisedatum',
      brand: 'Gebuchte LC-Marke',
      lengthOfStay: 'Aufenthaltsdauer (in Nächten)',
      cost: 'Gesamtkosten der Buchung',
      rooms: 'Anzahl der Zimmer',
      stay: 'Aufenthaltsdauer (in Nächten)',
      airline: 'Fluggesellschaft (2-stelliger Code)',
      gateway: 'Abflughafen (3-stelliger Code)',
      destination: 'Zielort / Insel (3-stelliger Code)',
      disclaimer: '* Pflichtfelder',
      button: 'Buchung einreichen',
      sub: 'Deine Informationen',
      sub2: 'Buchungsinformationen',
      editInfo: "Informationen bearbeiten",
      dropzone: "Datei hier ablegen oder klicken zum Auswählen.",
      dropzoneAcceptedFiles: "Eine Datei, .jpeg, .png und .pdf werden akzeptiert. Max. 100 MB.",
    },
    TermsAndConditions: {
      title: 'Geschäftsbedingungen',
      subTitle: 'Canada Specialist Quartals-Belohnungen',
      body1:
        'Jede Einreichung muss durch einen Nachweis mit Nullsaldo belegt sein. Die Preisträger werden basierend auf allen verifizierten Dokumenten ausgewählt. Belohnungen sind nicht übertragbar und müssen innerhalb von drei (3) Monaten eingelöst werden. Nicht beanspruchte Preise verfallen.',
      body2:
        'Zur Teilnahme musst du in den USA oder Kanada wohnen und volljährig sein. Reiseveranstalter-Mitarbeiter und Einwohner der Provinz Québec sind ausgeschlossen.',
      body3:
        'Zur Belohnungsausgabe kann ein Akkreditierungsnachweis erforderlich sein. Belohnungen können sich während des Programms ändern.',
      body4: 'Datenschutz und Verwendung persönlicher Daten',
      body5:
        'Teilnehmende erklären sich damit einverstanden, dass ihre Daten zur Preisvergabe und für Werbezwecke genutzt und ggf. an Dienstleister weitergegeben werden dürfen.',
      button: 'Zurück zur Startseite',
    },
    thankYouPage: {
      thanks: 'Vielen Dank',
      congrats: 'Glückwunsch, ',
      body: 'deine Buchung wurde erhalten und zur Prüfung weitergeleitet.',
      link: 'Bitte beachte, dass du die wesentlichen Module des Canada Specialist Programms abgeschlossen haben musst, um gewinnen zu können.',
    },
    bookingTable: {
      points: "Punkte",
      status: "Status",
      firstName: "Vorname",
      lastName: "Nachname",
      bookingDate: "Buchungsdatum",
      rooms: "Zimmer",
      cost: "Kosten",
    },
  },
  badgeView: {
    title: 'Achievements Dashboard',
    subtitle:
      'Willkommen zu Ihrem Achievements Dashboard, wo Sie Ihre Diplom- und Spezialisierungsabzeichen ansehen, verfolgen und herunterladen können.',
    viewBadge: 'Status anzeigen',
    badgeDisplayTitle: 'Leistungsstatus',
    badgeAchievement: 'Sie haben den Status {Rang} erreicht! Klicken Sie auf das Symbol auf der rechten Seite, um Ihren Status zu sehen und zu teilen.',
    badgesCompleteTitle: 'Ihre Spezialisierungsabzeichen',
    badgesCompleteSubtitle: 'Klicken Sie auf die Symbole, um Ihre Abzeichen anzuzeigen, zu speichern und zu teilen.',
    badgesIncompleteSubtitle: 'Verdiene weitere Abzeichen, indem du diese Kapitel abschließt.',
    bronze: 'Bronze',
    silver: 'Silber',
    gold: 'Gold',
    platinum: 'Platin',
    diploma: 'Diplom',
    badgeAchievementWithRewards: {
      start: 'Herzlichen Glückwunsch! Sie haben den Platin-Status erreicht. Klicken Sie auf ',
      link: 'hier',
      end: ', um Ihre Platin-Status-Belohnung zu erhalten.',
    }
  },
};
